/**
 * AOS scroll library
 * https://michalsnik.github.io/aos/
 */

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/themes/light.css';

const HELLOPANDA_TIPPY = {
  init: function() {

    if (tippy) {
      window.addEventListener('DOMContentLoaded', () => {
        tippy('[data-tippy-content]');
      });
    }

  }
};
HELLOPANDA_TIPPY.init();